/**
 * 移动端顶部栏
 */

import { ReactNode } from 'react'
import { Menu, ArrowLeft } from 'lucide-react'

interface MobileHeaderProps {
  /** 标题 */
  title?: string
  /** 是否显示返回按钮 */
  showBack?: boolean
  /** 返回按钮点击 */
  onBack?: () => void
  /** 菜单按钮点击 */
  onMenuClick?: () => void
  /** 右侧内容 */
  rightContent?: ReactNode
}

export function MobileHeader({
  title,
  showBack = false,
  onBack,
  onMenuClick,
  rightContent,
}: MobileHeaderProps) {
  return (
    <header
      className="sticky top-0 z-40"
      style={{
        background: 'var(--y-glass-hd)',
        backdropFilter: 'blur(24px) saturate(1.4)',
        WebkitBackdropFilter: 'blur(24px) saturate(1.4)',
        boxShadow: 'var(--y-shadow-hd)',
      }}
    >
      <div className="flex items-center justify-between h-12 px-3">
        {/* 左侧：返回或菜单按钮 */}
        <div className="w-[76px] flex items-center">
          {showBack ? (
            <button
              onClick={onBack}
              className="w-9 h-9 flex items-center justify-center rounded-[10px] active:bg-[var(--y-accent-light)] transition-colors"
              aria-label="Go back"
            >
              <ArrowLeft className="w-5 h-5 text-[var(--y-text-primary)]" strokeWidth={1.8} />
            </button>
          ) : (
            <button
              onClick={onMenuClick}
              className="w-9 h-9 flex items-center justify-center rounded-[10px] active:bg-[var(--y-accent-light)] transition-colors"
              aria-label="Open menu"
            >
              <Menu className="w-5 h-5 text-[var(--y-text-primary)]" strokeWidth={1.8} />
            </button>
          )}
        </div>

        {/* 中间：标题或品牌名 */}
        <div className="flex-1 flex items-center justify-center">
          {title ? (
            <h1 className="text-[16px] font-semibold text-[var(--y-text-primary)] tracking-[-0.01em] truncate max-w-[200px]">
              {title}
            </h1>
          ) : (
            <span className="text-[17px] font-bold text-[var(--y-accent)] tracking-[-0.02em]">
              Kommend
            </span>
          )}
        </div>

        {/* 右侧：自定义内容或占位 */}
        <div className="w-[76px] flex items-center justify-end">
          {rightContent}
        </div>
      </div>
    </header>
  )
}

